import { h } from 'preact'; /** @jsx h */

import './ParallaxContent.scss';

const ParallaxContent = ({ children, orientation = 'left' }) => {
    return (
        <div className={`parallax-content-wrapper content-${orientation}`}>
            <div className="parallax-content">{children}</div>
        </div>
    );
};

export default ParallaxContent;
